import { ThemeConfig } from 'antd/es/config-provider';
import { CSSProperties } from 'react';

export class UI {
  static getTheme = (): ThemeConfig => {
    return {
      token: {
        colorPrimary: '#0069F4',
        fontFamily: "'Noto Sans'",
      },
    };
  };

  static modalMaskStyle(): CSSProperties {
    return { backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)' };
  }
}
